import React from 'react'

import Menu from './menu/menu'
import FieldsList from './fields-list'
import FieldProto from "../../../../fields3/proto/field-proto"

let selectedSection: any = null

export type PopoverAddColumnProps = {
    manageColumnsConfig     : any[]

    fields                  : FieldProto[]
    columns?                : any[]
    mandatoryColumnsIds?    : ID[],

    noValueOption?          : {icon?: string, label: string}
    showAdd                 : boolean
    showModifierOptions?    : boolean   // show additional options for fields (i.e. interval for Date fields)

    hidePopover             : callback
    onToggleColumn          : callback
    onNewCustomField        : callback
}

export default class PopoverAddColumn extends React.Component<PopoverAddColumnProps,any> {

    constructor(props:PopoverAddColumnProps) {
        super(props);

        const section = selectedSection && !!_.find(this.props.manageColumnsConfig, g=>g.groupId === selectedSection) ? selectedSection : this.props.manageColumnsConfig[0].groupId //group.groupId or new-field

        this.state = {
            section: section
        };
    }

    onSelectSection = (section:string) => {
        switch (section) {
            case 'none':
                this.props.hidePopover()
                this.props.onToggleColumn(null)
                return

            case 'new-field':
                const company = gd.session.companies.get(gd.companyId)
                this.props.hidePopover()

                if (!company.license.customFields) {
                    gd.modals.other.upgradeToPro(gd.companyId)
                } else {
                    this.props.onNewCustomField()
                }
                return
        }

        selectedSection = section;

        this.setState({
            section: section
        })
    }

    render() {
        return (
            <div className="main">
                <Menu section           = {this.state.section}
                      onSelectSection   = {this.onSelectSection}
                      {...this.props} />

                <FieldsList section         = {this.state.section}
                            onSelectSection = {this.onSelectSection}
                            {...this.props} />
            </div>
        );
    }
}